const React = require('react');
const Tooltip = require('../../../../../Tooltip/A');
const formatNumFiat = require('../../../../../../../utils/formatNumFiat');

const displayFeeAmountCtor = (feesKey) => ({data, dataKey}) => {
  const fees = data[feesKey] || {};

  const value = fees[dataKey];
  const percent = fees[`${dataKey}_percent`];

  const symbol = ['rolling_reserve', 'tax'].includes(dataKey) ? 'INR' : data.fee_asset;

  return (
    <>
      <Tooltip title={value}>
        {formatNumFiat(value)} {symbol} {!!percent ? ` (${formatNumFiat(Number(percent) * 100)}%)` : ''}
      </Tooltip>
    </>
  )
}

const DisplayFeeRetailer = displayFeeAmountCtor('retailer_fees');
const DisplayFeeCustomer = displayFeeAmountCtor('customer_fees');

const FEES_RETAILER = [
  {
    title: 'Total Fee (without spread)',
    dataHandler: (data) => (
      <DisplayFeeRetailer data={data} dataKey="total_fee" />
    ),
  },
  {
    title: 'Total Fee',
    dataHandler: (data) => (
      <DisplayFeeRetailer data={data} dataKey="total_amount" />
    ),
  },
  {
    title: 'Transaction Fee',
    dataHandler: (data) => (
      <DisplayFeeRetailer data={data} dataKey="transaction_fee" />
    ),
  },
  {
    title: 'Exchange Spread',
    dataHandler: (data) => (
      <DisplayFeeRetailer data={data} dataKey="exchange_spread" />
    ),
  },
  {
    title: 'Lunu Fee',
    dataHandler: (data) => (
      <DisplayFeeRetailer data={data} dataKey="fixed_fee_lunu" />
    ),
  },
  {
    title: 'Referral Fee',
    dataHandler: (data) => (
      <DisplayFeeRetailer data={data} dataKey="fixed_fee_referral" />
    ),
  },
  {
    title: 'Rolling Reserve',
    dataHandler: (data) => (
      <DisplayFeeRetailer data={data} dataKey="rolling_reserve" />
    ),
  },
  {
    title: 'Tax',
    dataHandler: (data) => (
      <DisplayFeeRetailer data={data} dataKey="tax" />
    ),
  },
];

const FEES_CUSTOMER = [
  {
    title: 'Total Fee (without spread)',
    dataHandler: (data) => (
      <DisplayFeeCustomer data={data} dataKey="total_fee" />
    ),
  },
  {
    title: 'Total Fee',
    dataHandler: (data) => (
      <DisplayFeeCustomer data={data} dataKey="total_amount" />
    ),
  },
  {
    title: 'Transaction Fee',
    dataHandler: (data) => (
      <DisplayFeeCustomer data={data} dataKey="transaction_fee" />
    ),
  },
  {
    title: 'Exchange Spread',
    dataHandler: (data) => (
      <DisplayFeeCustomer data={data} dataKey="exchange_spread" />
    ),
  },
  {
    title: 'Lunu Fee',
    dataHandler: (data) => (
      <DisplayFeeCustomer data={data} dataKey="fixed_fee_lunu" />
    ),
  },
  {
    title: 'Referral Fee',
    dataHandler: (data) => (
      <DisplayFeeCustomer data={data} dataKey="referral_fee" />
    ),
  },
  {
    title: 'Referral Fee (Fixed)',
    dataHandler: (data) => (
      <DisplayFeeCustomer data={data} dataKey="fixed_fee_referral" />
    ),
  },
];

module.exports = {
  FEES_RETAILER,
  FEES_CUSTOMER,
};
